import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { brand } from "@/data/site";

const nav = [
    { to: "/", label: "Beranda" },
    { to: "/order", label: "Cek Status" },
    { to: "/rules", label: "Rules" },
    { to: "/tentang-kami", label: "Tentang" },
    { to: "/kontak", label: "Kontak" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 backdrop-blur-md bg-white/90 border-b border-[color:var(--wx-line)] overflow-visible"
        >
            <div className="wx-container flex items-center justify-between h-[76px] sm:h-[72px] overflow-visible">
                <Link
                    to="/"
                    data-testid="brand-link"
                    onClick={() => setOpen(false)}
                    className="inline-flex items-center self-start pt-[13px] sm:pt-[15px] -ml-1.5 sm:-ml-2 overflow-visible"
                    aria-label="WxFaous — beranda"
                >
                    <img
                        src={brand.logoUrl}
                        alt="WxFaous"
                        className="w-[165px] sm:w-[190px] h-auto select-none block"
                        draggable={false}
                    />
                </Link>

                <nav className="hidden sm:flex items-center gap-5">
                    {nav.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.to === "/"}
                            data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
                            className={({ isActive }) =>
                                `text-sm transition-colors ${
                                    isActive
                                        ? "text-[color:var(--wx-blue)] font-semibold"
                                        : "text-[color:var(--wx-muted)] hover:text-[color:var(--wx-ink)]"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <button
                    type="button"
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="sm:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg border border-[color:var(--wx-line)] text-[color:var(--wx-ink)]"
                    aria-label="Toggle menu"
                    aria-expanded={open}
                    aria-controls="mobile-navigation"
                >
                    {open ? (
                        <X className="w-4 h-4" />
                    ) : (
                        <Menu className="w-4 h-4" />
                    )}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    id="mobile-navigation"
                    className="sm:hidden border-t border-[color:var(--wx-line)] bg-white"
                >
                    <div className="wx-container py-2 flex flex-col">
                        {nav.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.to === "/"}
                                onClick={() => setOpen(false)}
                                data-testid={`mnav-${n.to.replace(/\//g, "") || "home"}`}
                                className={({ isActive }) =>
                                    `py-3 text-sm ${
                                        isActive
                                            ? "text-[color:var(--wx-blue)] font-semibold"
                                            : "text-[color:var(--wx-ink)]"
                                    }`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
